/* eslint-disable import/prefer-default-export */
import { useState } from "react";
import { http } from "utils/http";

/* TODO: Move file */
export const useBranches = () => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  const [error, setError] = useState(null);
  const [query, setQuery] = useState("");

  function fetchBranches({ query: searchQuery }) {
    const porbableQuery = searchQuery || query;

    const url = `/agency?${searchQuery}`;

    setQuery(porbableQuery);
    setLoading(true);

    http
      .get(url)
      .then(res => {
        setData(res.data);
      })
      .catch(err => setError(err))
      .finally(() => setLoading(false));
  }

  return [fetchBranches, { loading, data, error }];
};
